import { NbToastrService } from '@nebular/theme';
/*
 * Copyright (c) Akveo 2019. All Rights Reserved.
 * Licensed under the Single Application / Multi Application License.
 * See LICENSE_SINGLE_APP / LICENSE_MULTI_APP in the 'docs' folder for license information on type of purchased license.
 */

import { Injectable } from '@angular/core';
import { NbAuthService } from '@nebular/auth';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, Router} from '@angular/router';
import { Observable, Subject } from 'rxjs';
import { takeUntil, tap } from 'rxjs/operators';
import { UserStore } from './user.store';
import { InitUserService } from './init-user.service';
import { NbRoleProvider } from '@nebular/security';
import { map } from 'rxjs/operators';
import { ROLES } from './roles';
@Injectable()
export class AuthGuard implements CanActivate {

  private destroy$: Subject<void> = new Subject<void>();

  constructor(
    private authService: NbAuthService,
    private router: Router,
    private userStore: UserStore,
    private userInit: InitUserService,
    private toastrService: NbToastrService,
    private roleProvider: NbRoleProvider,
    ) {}

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot,
  ): Observable<boolean> | Promise<boolean> | boolean {

    return this.authService.isAuthenticated()
      .pipe(
        tap(authenticated => {
          if (!authenticated) {
            this.router.navigate(['auth/register']);
          }


          this.roleProvider.getRole().pipe(map(role => {
            const roles = role instanceof Array ? role : [role];
            let isAuth =  roles.some(x => ROLES.ADMIN);
              // (x && x.toLowerCase() === ROLES.CHANGE_FORM_REQUEST_SUBMITTER ||
              // x && x.toLowerCase() ===  ROLES.ADMIN ||
              // x && x.toLowerCase() ===  ROLES.CHANGE_FORM_REQUEST_REVIEWER ||
              // x && x.toLowerCase() ===  ROLES.ATTENDANCE_SHEET_MANAGER));

              if (!isAuth) this.router.navigate(['auth/register']);
              return isAuth;
          }));

         this.userStore.onUserStateChange().pipe(
            takeUntil(this.destroy$),
          )
          .subscribe((user) => {
            if (user?.password_expired){
              this.router.navigate(['auth/change-password']);
              this.toastrService.show(
                ``,
                `Change password to proceed`,
                {
                  duration: 6000,
                  status: 'info',
                  icon: 'lock-outline',
                }
              )
            }
          })

      }),
    );
  }
}
